import { render, staticRenderFns } from "./InvoiceViewDetails.vue?vue&type=template&id=47a3624f&"
import script from "./InvoiceViewDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports